import Vue from 'vue'
import Bubble from '@bilibili-studio/bubble'
import '@bilibili-studio/bubble/dist/bubble.css'
import './main.scss'
import './style/font/MF-SiYan.css'
import '@bilibili-live/opt-header/dist/style.css'
import App from './App.vue'
import router from './routers'
import store from './stores'
import api from './apis'
import AcFileUpload from './components/FileUpload.vue'
import VIcon from "./components/VIcon"
import Confirm from './components/comfirm'
import LogReport from './utils/log-report'

Vue.use(Bubble)
Vue.prototype.$message = Bubble.Message
Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$bus = new Vue()
Vue.prototype.$confirm = Confirm
Vue.component('ac-file-upload', AcFileUpload)
Vue.component('v-icon', VIcon)
Vue.prototype.$LogReport = LogReport

Vue.mixin({
  methods: {
    replaceHTTPResource(uri) {
      if (!uri) return ''
      return uri.replace(/^https?:/, '')
    }
  }
})

window.$bili_arcopen = {
  isUAT: /^uat-/.test(location.host)
  // isUAT: true
}
Vue.prototype.$bili_arcopen = window.$bili_arcopen

window.EDITOR_URL = `https://${/^uat-/.test(location.hostname) ? 'uat-' : ''}s1.hdslb.com/bfs/static/studio/static/doc-it/v2/editor.md`

const requireAll = (requireContext) => requireContext.keys().map(requireContext)
const req = require.context('./assets/svg-sprite', false, /\.svg$/)
requireAll(req)

if (/\/open/.test(location.href) && !/\/openhome/.test(location.href)) {
  window.location.href = `https://${/^uat-/.test(window.location.href) ? 'uat-' : ''}openhome.bilibili.com`  
}

if (process.env.NODE_ENV !== 'development') {
  const targetProtocol = 'https:'
  if (window.location.protocol !== targetProtocol) {
    window.location.href = targetProtocol + window.location.href.substring(window.location.protocol.length)
  }
}

let loadDocStyle = () => {
  let styleNode = document.createElement('link')
  styleNode.setAttribute('rel', 'stylesheet')
  styleNode.setAttribute('type', 'text/css')
  styleNode.setAttribute('href', `${window.EDITOR_URL}/css/editormd.preview.min.css`)
  document.getElementsByTagName('head')[0].appendChild(styleNode)
}
loadDocStyle()

Vue.mixin({
  methods: {
    showWarning() {
      // this.$message({
      //   content: '功能敬请期待',
      //   type: 'query',
      //   duration: 1000,
      //   offset: 60
      // })
    }
  }
})

;(async () => {
  await Promise.all([
    store.dispatch('getUserInfo'),
    store.dispatch('getCompanyInfo')
  ])

  if (!store.state.companyInfo) {
    // 未登录，注册登录组件
    window._miniLogin_ = new window.MiniLogin()
    window._miniLogin_.addEventListener('success', (data) => {
      // {
      //      type,   // 'login' || 'register' 分别表示登录和注册行为
      //      by      // 'phone' || 'qrcode' || 'message-new' || 'message-old' || 'password' || 'third-login'  // 分别代表 手机注册、扫码登录、新用户短信登录、老用户短信登录、密码登录、第三方登录
      //      login_type, // 'weibo' 、 'qq'、 'wechat'
      if (data.type.type === 'register') {
        LogReport.sendCustomEvent('openplat_register_succeed')
      } else {
        LogReport.sendCustomEvent('openplat_login_succeed')
      }
      try {
        localStorage.removeItem('arcopenComanyAddInfo')
      } catch (e) {
        console.error(e)
      }
      window.location.reload()
      // store.dispatch('getUserInfo')
      // store.dispatch('getCompanyInfo')
    })
    window._miniLogin_.addEventListener('cancel',  () => {   // 监听用户关闭迷你登录框事件
      // 取消
    })
  }
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
})().catch(e => {
  console.error(e)
})
